<template>
  <div class="read-paper container">
    <el-breadcrumb class="breadcrumb"
                   separator="/">
      <el-breadcrumb-item>内容管理</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: `/read` }">阅读资料</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: `/read/detail/${this.$route.params.readId}` }">{{ chapter.read_name }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ chapter.name }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="header">
      <div class="content">
        <div class="left">
          <div class="status">
            <span class="label">章节上线状态：</span>
            <el-switch v-model="chapter.status"
                       @change="handleUpdateChapterStatus"></el-switch>
            <span style="color: #999999; margin-left: 17px">
              知识点编辑为实时保存，建议编辑时先关闭对应章节的上线状态，避免影响用户操作
            </span>
          </div>

          <div class="title-wrap">
            <div class="input-box">
              <span>知识点集合名称：</span>
              <el-input v-model="paper.name"
                        placeholder="在未自定义修改的情况下，组卷名称会默认跟随章节"
                        @change="handlePaperNameChange"></el-input>
            </div>
          </div>
          <!-- <div class="tips">
            <p class="label">
              <i class="el-icon-warning-outline"></i>
              知识点编辑为实时保存，建议编辑时先关闭对应章节的上线状态，避免影响用户操作
            </p>
          </div> -->
        </div>
        <!-- <div class="right">
          <el-button
            type="primary"
            @click="handleToPreview"
          >预览</el-button>
        </div> -->
      </div>
    </div>

    <div class="main">
      <!-- <div class="title-wrap">
        <div class="input-box">
          <span>知识点集合名称：</span>
          <el-input
            v-model="paper.name"
            placeholder="编辑知识点集合名称"
            @change="handlePaperNameChange"
          ></el-input>
          <el-tooltip
            class="item"
            effect="dark"
            content="在未自定义修改的情况下，组卷名称会默认跟随章节"
            placement="top-start"
          >
            <i
              class="el-icon-info"
              style="margin-left: 10px;"
            ></i>
          </el-tooltip>
        </div>
      </div> -->
      <div class="read-wrap">
        <div class="read-item"
             v-for="(item, $index) in itemList"
             :key="item.id">
          <Read :paper_id="chapter.paper_id"
                :paperName="paper.name"
                :content="item"
                @save="handleReadSave($event, $index)"
                :isAuthor="readInfo.author == null ? false : true">
            <div style="display: flex">
              <div v-if="$index != 0">
                <el-button type="text"
                           @click="handleReadSortChange($index, 'up')">上移</el-button>
                <el-divider class="divider"
                            direction="vertical"></el-divider>
              </div>
              <div v-if="$index != itemList.length - 1">
                <el-button type="text"
                           @click="handleReadSortChange($index, 'down')">下移</el-button>
                <el-divider class="divider"
                            direction="vertical"></el-divider>
              </div>
              <el-button type="text"
                         @click="handleReadRemove($index)">删除</el-button>
            </div>
          </Read>
        </div>
        <div class="read-add"
             @click="handleReadAdd()">+添加知识点</div>
        <!-- <el-button class="read-add" type="primary" @click="handleReadAdd()"
          >+添加知识点</el-button
        > -->
      </div>
    </div>
  </div>
</template>

<script>
import Read from '@/components/read/Read'
import {
  readOne,
  readChapterOne,
  readPaperOne,
  readPaperUpdate,
  readChapterUpdate,
  readPaperItemList,
  readPaperItemCreate,
  readPaperItemUpdate,
  readPaperItemsUpdate,
  readPaperItemDestroy,
} from '@/api/read'

export default {
  components: {
    Read,
  },
  data() {
    return {
      chapter: {},
      paper: {},
      itemList: [],
      readInfo: {},
    }
  },
  created() {
    this.fetchReadChapterInfo()
    this.fetchReadInfo()
  },
  mounted() {
    this.scrollToTop()
  },
  methods: {
    // 阅读资料基本信息
    fetchReadInfo() {
      readOne({ id: this.$route.params.readId }).then((res) => {
        if (res) {
          this.readInfo = res
        }
      })
    },
    // 阅读资料基本信息
    fetchReadChapterInfo() {
      readChapterOne({ id: this.$route.params.chapterId }).then((res) => {
        if (res) {
          // console.log('res:', res)
          this.chapter = res
          this.chapter.status = this.chapter.status === 1 ? true : false
          this.fetchReadPaperInfo()
          this.fetchReadPaperItemList()
        }
      })
    },
    // 试卷基本信息
    fetchReadPaperInfo() {
      readPaperOne({ id: this.chapter.paper_id }).then((res) => {
        if (res) {
          this.paper = res
        }
      })
    },
    // 试卷知识点列表
    fetchReadPaperItemList() {
      readPaperItemList({ paper_id: this.chapter.paper_id }).then((res) => {
        this.itemList = res.list || []
        this.itemList.forEach((item) => {
          if (item.options) {
            item.options.forEach((v) => {
              v.true_option = v.true_option === 1 ? true : false
            })
          }
        })
      })
    },
    // 章节发布状态变更
    handleUpdateChapterStatus(value) {
      readChapterUpdate({ id: this.chapter.id, status: value ? 1 : 0 })
        .then((res) => {})
        .catch((error) => {
          this.$message.error('章节在线状态更新异常')
          console.log('error: ', error)
        })
    },
    // 试卷名称变更
    handlePaperNameChange(value) {
      readPaperUpdate({ id: this.paper.id, name: value })
        .then((res) => {})
        .catch((error) => {
          this.$message.error('试卷名称更新异常')
          console.log('error: ', error)
        })
    },
    // 滚动到页面顶部
    scrollToTop() {
      // Chrome
      document.body.scrollTop = 0
      // Firefox
      document.documentElement.scrollTop = 0
      // Safari
      window.pageYOffset = 0
    },
    // 知识点保存
    handleReadSave(event, index) {
      this.itemList[index].content = event
    },
    // 知识点排序
    handleReadSortChange(index, type) {
      let old = this.itemList.splice(index, 1)[0]
      if (type == 'up') {
        this.itemList.splice(index - 1, 0, old)
      } else if (type == 'down') {
        this.itemList.splice(index + 1, 0, old)
      }
      const rows = this.itemList.map((item, sort) => {
        return { id: item.id, sort: sort }
      })
      readPaperItemsUpdate(rows)
        .then((res) => {})
        .catch((error) => {
          this.$message.error('知识点排序更新异常')
          console.log('error: ', error)
        })
    },
    // 知识点删除
    handleReadRemove(index) {
      readPaperItemDestroy({ id: this.itemList[index].id }).then((res) => {
        this.itemList.splice(index, 1)
      })
    },
    // 知识点添加
    handleReadAdd(type) {
      let itemValue = {
        paper_id: this.paper.id,
        answer_type: type,
        sort: this.itemList.length,
      }
      if (type === 8) {
        itemValue.material = 1
      }
      readPaperItemCreate(itemValue).then((res) => {
        this.itemList.push(res)
      })
    },
    // 预览
    handleToPreview() {
      // if (this.paper) {
      //   if (location.host.includes('admin.koudaikaoyan.com')) {
      //     window.open(`https://www.koudaikaoyan.com/read/paper?source=paper&paperId=${this.paper.id}&name=${this.paper.name}`)
      //   } else {
      //     window.open(`http://test.koudaikaoyan.com/read/paper?source=paper&paperId=${this.paper.id}&name=${this.paper.name}`)
      //   }
      // }
    },
  },
}
</script>

<style scoped lang="less">
.read-paper {
  padding: 24px;
  .header {
    background: #fff;
    padding: 20px;
    margin-top: 23px;
    .breadcrumb {
      margin-bottom: 20px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title-wrap {
        display: flex;
        justify-content: space-between;
        margin-top: 18px;
      }
      .input-box {
        display: flex;
        align-items: center;
        flex: 1;

        .el-input {
          width: 744px;
        }
      }
    }
    .tips {
      font-size: 12px;
      color: #999;
      margin-top: 5px;
    }
  }
  .main {
    // background: #fff;
    // padding: 20px;
    margin-top: 12px;

    .read-item {
      margin-top: 24px;
    }
    .read-item:first-child {
      margin-top: 0;
    }
    .read-add {
      position: relative;
      color: #303133;
      background-color: #fff;
      border: 1px dashed #1890ff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      background: #ecf2fe;
      border-radius: 2px;
      // overflow: hidden;
      // padding: 20px;
      height: 56px;
      line-height: 56px;
      text-align: center;
      margin-top: 24px;

      width: 100%;
      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #1890ff;
    }
  }
}
</style>
